import React, { useState, useEffect } from "react";

export default function SiteModal({ open, onClose, mode, initialSite, onSubmit }) {
  const [form, setForm] = useState({
    id: null,
    name: "",
    address: "",
    timezone: "America/Vancouver",
  });

  useEffect(() => {
    if (mode === "edit" && initialSite) {
      setForm(initialSite);
    } else if (mode === "add") {
      setForm({ id: null, name: "", address: "", timezone: "America/Vancouver" });
    }
  }, [mode, initialSite, open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/70 z-50">
      <div className="bg-neutral-800 text-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">
          {mode === "edit" ? "Edit Site" : "Add Site"}
        </h2>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const payload = { ...form };
            if (mode === "add") delete payload.id;
            onSubmit(payload);
          }}
          className="space-y-4"
        >
          <input
            type="text"
            placeholder="Site name"
            value={form.name || ""}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            required
            className="w-full border border-gray-600 rounded p-2 bg-neutral-900 text-white focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="text"
            placeholder="Address"
            value={form.address || ""}
            onChange={(e) => setForm({ ...form, address: e.target.value })}
            className="w-full border border-gray-600 rounded p-2 bg-neutral-900 text-white focus:ring-2 focus:ring-blue-500"
          />
          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded"
            >
              {mode === "edit" ? "Save Changes" : "Create"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

